import GenerateSlug from '@/plugin/generateSlug'

export default class TeamsRoute extends GenerateSlug<{
  location: string
  department: string
  // page: number | null
}> {
  constructor() {
    super({
      location: '',
      department: '',
      // page: null,
    })
  }
}
